<template>
  <div id="app">
    <game />
  </div>
</template>

<script>
import Game from './components/Game.vue'

export default {
  name: 'App',

  components: {
    Game
  }
}
</script>

<style lang="sass">
*
  box-sizing: border-box

body
  background: #000000

h1, h2, h3, h4, h5, p, hr
  margin: 0
  padding: 0

#app
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
</style>
